// PageVariablesApolices.js

export const pageVariables = {
    headers: [
        'NOME','EMPRESA', 'NUMERO', 'CALCULO iDADE','DATA ULTIMO IPCA','DATA ULTIMO REENQUADRAMENTO','DATA INICIAL','SEGURADO','PLANO'
    ],
    headerInfo: {
        title: "Apólices",
        description: "Esta seção fornece informações detalhadas sobre as apólices, incluindo dados como segurado, tipo de cobertura, valor da apólice e vigência. Acompanhe e gerencie as apólices emitidas para garantir que estejam adequadas às necessidades dos segurados e cumpram as exigências contratuais."
    },     
    inputs: [
        {
            name: "empresa_id",
            type: "text",
            label: "Empresa"
        },
        {
            name: "nome",
            type: "text",
            label: "Nome"
        },
        {
            name: "numero",
            type: "text",
            label: "Numero"
        },
        {
            name: "calculo_idade",
            type: "text",
            label: "Calculo de idade"
        },
        {
            name: "data_ultimo_ipca",
            type: "text",
            label: "Data Ultimo IPCA"
        },
        {
            name: "data_ultimo_reenquadramento",
            type: "text",
            label: "Data Ultimo Reequadramento"
        }
        ,
        {
            name: "data_inicial",
            type: "text",
            label: "Data Inicial"
        }
        ,
        {
            name: "plano_id",
            type: "text",
            label: "Plano"
        }
    ],
    page: process.env.VUE_APP_API_URL+"apolices",
};
